import { defineOnboardingSection } from "onboarding/utils";

const orderedSteps = ["Intro"];

export const WELCOME_TRACK = defineOnboardingSection({
  orderedSteps,
  prefix: "",
  sectionName: "welcome",
  steps: orderedSteps,
});
export default WELCOME_TRACK;
